import { FC } from 'react';
import SectionTitle from '@/components/ui/section-title/SectionTitle';
import BookCardItem from '@/components/ui/book-card-item/BookCardItem';
import BooksBtn from '@/components/ui/books-btn/BooksBtn';
import { IBookPage } from '@/interfaces/booksPage.interface';
import styles from './FreebooksBlock.module.scss';

interface IFreebooksBlock {
  books: IBookPage;
}

const FreebooksBlock: FC<IFreebooksBlock> = ({ books }) => {
  return (
    <div className={styles.freebooks}>
      <div data-btn-cards="tiles">
        <SectionTitle name={'Бесплатные книги'} />
      </div>
      <div data-cards="list" className="cardsWrapper">
        {books.data.length &&
          books.data.map((book) => <BookCardItem key={book.id} createdAt={book.created_at} alias={book.alias} rating={book.rating} author={book.author} book={book.book} draft={book.draft} readOnline={book.read_online} retelling={!!book.retaling} />)}
      </div>
      <div className={styles.freebooks__btnWrap}>
        <BooksBtn alias="/free_books/" title="Все бесплатные книги" />
      </div>
    </div>
  );
};
export default FreebooksBlock;
